module.exports = __webpack_public_path__ + "b3889a6339497179bca0d1925d3fb6e5.png";